<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="member.id === null">{{ 'NEWMEMBER' | translate }}</span>
            <span *ngIf="member.id !== null">{{ 'EDITMEMBER' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="memberForm" id="memberForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="memberForm" >
            <input type="hidden" name="id" id="memberId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="memberName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="memberName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="memberForm.controls['name'].invalid && (memberForm.controls['name'].dirty || memberForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="memberForm.controls['name'].errors !== null">
                  <div *ngIf="memberForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="memberUserId" [autoDisplayFirst]="false" formControlName="user" [options]="membersColumnsService.users" optionValue="id" optionLabel="username" [required]="true" [filter]="true"></p-dropdown>
                      <label for="memberUserId" class="req">{{ 'USER' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="memberForm.controls['user'].invalid && (memberForm.controls['user'].dirty || memberForm.controls['user'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="memberForm.controls['user'].errors !== null">
                  <div *ngIf="memberForm.controls['user'].errors.required">
                   {{ 'USERREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-info-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="memberDescription" formControlName="description" type="text" pInputText [required]="false"> 
                      <label for="memberDescription" class="">{{ 'DESCRIPTION' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="memberPhoto" formControlName="photo" type="text" pInputText [required]="false"> 
                      <label for="memberPhoto" class="">{{ 'PHOTO' | translate }}</label>
                    </span>
                    <button type="button" pButton pRipple icon="pi pi-folder" styleClass="p-button-info" (click)="openFilerDialog('photo')"></button> 
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-ruler"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="memberHeight" formControlName="height" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="memberHeight" class="">{{ 'HEIGHT' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-dashboard"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="memberWeight" formControlName="weight" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [step]="0.1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="memberWeight" class="">{{ 'WEIGHT' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="memberIsPublished" formControlName="isPublished" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="memberIsPublished" class="p-d-inline-block p-ml-2 req">{{ 'ISPUBLISHED' | translate }}</label>
                </div>
                <div *ngIf="memberForm.controls['isPublished'].invalid && (memberForm.controls['isPublished'].dirty || memberForm.controls['isPublished'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="memberForm.controls['isPublished'].errors !== null">
                  <div *ngIf="memberForm.controls['isPublished'].errors.required">
                   {{ 'ISPUBLISHEDREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-12">
                <label for="memberFitnessGoals" class="control-label">
                  <span>
                    {{ 'FITNESSGOALS' | translate }}
                  </span>
                  <span class="input-icon">
                    <input placeholder="{{ 'FILTERFITNESSGOALS' | translate }}" type="text" #fitnessGoalsSearchText (input)="membersColumnsService.filterFitnessGoals(fitnessGoalsSearchText.value)" class="form-control pull-right input-sm underline" />
                      <i class="icon-filter"></i>
                   </span><!--/input-icon-->
                </label>
              </div><!--/p-col-12-->
              <ng-container *ngFor="let fitnessGoal of membersColumnsService.fitnessGoalsFiltered">
                <div class="p-col-3 p-field-checkbox" *ngIf="fitnessGoal.id">
                  <p-checkbox name="fitnessGoals" [formControl]="$any(memberForm).controls['fitnessGoals']" [value]="fitnessGoal.id" label="{{ fitnessGoal.name }}"></p-checkbox>
                </div><!--/p-col-3-->
              </ng-container>
              <div class="p-col-12">
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="toggleAllFitnessGoals($event)" id="memberFitnessGoals" label="{{ 'SELECTALL' | translate }}"></p-checkbox>
                </div><!--/checkbox-->
              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">
                <label for="memberSports" class="control-label">
                  <span>
                    {{ 'SPORTS' | translate }}
                  </span>
                  <span class="input-icon">
                    <input placeholder="{{ 'FILTERSPORTS' | translate }}" type="text" #sportsSearchText (input)="membersColumnsService.filterSports(sportsSearchText.value)" class="form-control pull-right input-sm underline" />
                      <i class="icon-filter"></i>
                   </span><!--/input-icon-->
                </label>
              </div><!--/p-col-12-->
              <ng-container *ngFor="let sport of membersColumnsService.sportsFiltered">
                <div class="p-col-3 p-field-checkbox" *ngIf="sport.id">
                  <p-checkbox name="sports" [formControl]="$any(memberForm).controls['sports']" [value]="sport.id" label="{{ sport.name }}"></p-checkbox>
                </div><!--/p-col-3-->
              </ng-container>
              <div class="p-col-12">
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="toggleAllSports($event)" id="memberSports" label="{{ 'SELECTALL' | translate }}"></p-checkbox>
                </div><!--/checkbox-->
              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKMEMBERS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="member.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!memberForm.valid || disableSubmit"> <!--  [disabled]="memberForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!memberForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

